<template>
  <div class="data-radius" :style="{borderRadius: '4px'}">
    <el-row class="card-row" :gutter="15" align="middle">
        <el-col :span="15">
          <el-text class="mx-1">{{getI18n('查询地址', 'Query Website')}}:</el-text>
          <el-text class="mx-1"><span class="font-red">https://{{refHost}}/</span></el-text>
        </el-col>
        <el-col :span="9" class="col-button">
        <el-button plain @click="querySimData()">
          <span type="success">{{getI18n('查询SIM卡','Query SIM')}}</span>
          <el-icon><ArrowDown v-if="!refIsExpand"/><ArrowUp v-if="refIsExpand" /></el-icon>
        </el-button>
      </el-col>
    </el-row>
    <template v-if="store.state.isQueriedSim">
      <el-row class="card-row" :gutter="20" align="middle">
        <el-col :span="9" class="col-title">
          <el-text class="mx-1">{{getI18n('卡号', 'SimNo')}}:</el-text>
        </el-col>
        <el-col :span="15">
          <el-text class="mx-1" type="primary">{{refSimNo}}</el-text>
        </el-col>
      </el-row>
      <el-row class="card-row" :gutter="20" align="middle">
        <el-col :span="9" class="col-title">
          <el-text class="mx-1">{{getI18n('ICCID', 'ICCID')}}:</el-text>
        </el-col>
        <el-col :span="15">
          <el-text class="mx-1" type="primary">{{refIccid}}</el-text>
        </el-col>
      </el-row>
      <el-row class="card-row" :gutter="20" align="middle">
        <el-col :span="9" class="col-title">
          <el-text class="mx-1">{{getI18n('msisdn', 'msisdn')}}:</el-text>
        </el-col>
        <el-col :span="15">
          <el-text class="mx-1" type="primary">{{refMsisdn}}</el-text>
        </el-col>
      </el-row>
      <el-row class="card-row" :gutter="20" align="middle">
        <el-col :span="9" class="col-title">
          <el-text class="mx-1">{{getI18n('运营商', 'Carrier')}}:</el-text>
        </el-col>
        <el-col :span="15">
          <el-text class="mx-1" type="primary">{{getCarrier()}}</el-text>
        </el-col>
      </el-row>
      <el-row class="card-row" :gutter="20" align="middle">
        <el-col :span="9" class="col-title">
          <el-text class="mx-1">{{getI18n('卡类型', 'Card Type')}}:</el-text>
        </el-col>
        <el-col :span="15">
          <el-text class="mx-1" type="primary">{{getCardType()}}</el-text>
        </el-col>
      </el-row>
      <el-row class="card-row" :gutter="20" align="middle">
        <el-col :span="9" class="col-title">
          <el-text class="mx-1">{{getI18n('SIM卡过期时间', 'SIM Expire Time')}}:</el-text>
        </el-col>
        <el-col :span="15">
          <el-text class="mx-1" type="primary">{{refSimExpireTime}}</el-text>
        </el-col>
      </el-row>
      <el-row class="card-row" :gutter="20" align="middle" v-if="refRealName1">
        <el-col :span="9" class="col-title">
          <el-text class="mx-1">{{getI18n('实名结果', 'Real Name Result')}}:</el-text>
        </el-col>
        <el-col :span="15" v-if="refRealName1">
          <el-text class="mx-1" type="primary">{{refRealName1}}</el-text>
        </el-col>
      </el-row>
      <el-row class="card-row" :gutter="20" align="middle">
        <el-col :span="9" class="col-title">
        </el-col>
        <el-col :span="15" v-if="refRealName2">
          <el-text class="mx-1" type="primary">{{refRealName2}}</el-text>
        </el-col>
      </el-row>
      <el-row class="card-row" :gutter="20" align="middle" v-if="getCardType ()=='ESIM'">
        <el-col :span="9" class="col-title">
          <el-text class="mx-1">{{getI18n('ESIM安装设备', 'Installed Device')}}:</el-text>
        </el-col>
        <el-col :span="15">
          <el-text class="mx-1" type="primary">{{refInstalledDevice}}</el-text>
        </el-col>
      </el-row>
      <el-row class="card-row" :gutter="20" align="middle"  v-if="getCardType ()=='ESIM'">
        <el-col :span="9" class="col-title">
          <el-text class="mx-1">{{getI18n('ESIM安装状态', 'Installed Status')}}:</el-text>
        </el-col>
        <el-col :span="15">
          <el-text class="mx-1" type="primary">{{ refInstalledStatus }}</el-text>
        </el-col>
      </el-row>
      <el-row class="card-row" :gutter="20" align="middle">
        <el-col :span="9" class="col-title">
          <el-text class="mx-1">{{getI18n('当前位置', ' Current Location')}}:</el-text>
        </el-col>
        <el-col :span="15">
          <el-text class="mx-1" type="primary">{{refLocation}}</el-text>
        </el-col>
      </el-row>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, defineProps, ref, onMounted } from 'vue'
import { ArrowDown, ArrowUp } from '@element-plus/icons-vue'
import { getI18n, convertUTC2LocalTime2, getCountryNameByMcc, apiPostData, isChinese, isEmptyArray } from '../utils'
import store from '../store'

export default defineComponent({
  name: 'SimCard'
})
</script>

<script lang="ts" setup>
const props = defineProps({
  simNo: {
    type: String,
    require: true
  }
})

const refHost = ref('')
onMounted(async () => {
  refHost.value = window.location.host
})

const refSimExpireTime = ref('')
const refSimNo = ref('')
const refIccid = ref('')
const refCarrier = ref('')
const refCardTye = ref('')
const refMsisdn = ref('')

function querySimData () {
  store.state.isQueriedSim = !store.state.isQueriedSim
  if (!store.state.isQueriedSim) {
    return
  }
  refSimExpireTime.value = convertUTC2LocalTime2(store.state.simInfo.data.expireTime)
  if (!isEmptyArray(store.state.simInfo.data.realNameCertList)) {
    refRealName1.value = getRealNameResult(0)
    refRealName2.value = getRealNameResult(1)
  }
  refSimNo.value = store.state.simInfo.data.simNo
  refIccid.value = store.state.simInfo.data.iccid
  refMsisdn.value = store.state.simInfo.data.msisdn
  refCarrier.value = store.state.simInfo.data.carrier || store.state.simInfo.data.sourceType
  refCardTye.value = store.state.simInfo.data.cardType

  refLocation.value = ''
  refInstalledDevice.value = ''
  refInstalledStatus.value = ''

  getLocation()
  queryEsimInfo()
}
function getRealNameResult (idx) {
  let certStatus = store.state.simInfo.data.realNameCertList[idx].certStatus
  const region = store.state.simInfo.data.realNameCertList[idx].region

  const certStatusMap = {
    Uncertified: '未实名',
    ToBeCertified: '待认证',
    Certifying: '认证中',
    Certified: '已认证',
    CertFailed: '认证失败',
    CertExpired: '实名过期',
    Unknow: '未知'
  }

  if (isChinese()) {
    certStatus = certStatusMap[certStatus]
  }

  return region + ' : ' + certStatus
}

const refIsExpand = ref(false)
const refRealName1 = ref('')
const refRealName2 = ref('')
const refLocation = ref('')
function getLocation () {
  refLocation.value = ''
  const data = { simNo: store.state.simInfo.data.simNo }
  apiPostData('/h5/v1/sim/get-location', data)
    .then(data => {
      console.log('getLocation', data)
      if (data !== null && data !== undefined && data.code === 'ok') {
        refLocation.value = getCountryNameByMcc(data.data.mcc)
      }
    })
}

const refInstalledDevice = ref('')
const refInstalledStatus = ref('')

function queryEsimInfo () {
  if (getCardType() !== 'ESIM') {
    return
  }
  refLocation.value = ''
  const data = { simNo: store.state.simInfo.data.simNo }
  apiPostData('/h5/v1/esim/get-info', data)
    .then(data => {
      console.log('queryEsimInfo', data)
      if (data !== null && data !== undefined) {
        console.log('queryEsimInfo', data)
        if (data.code === 'ok') {
          data = data.data
          refInstalledDevice.value = data.installDevice
          refInstalledStatus.value = data.status
          if (data.status === 'Released') {
            refInstalledStatus.value = getI18n('未安装', 'Uninstall')
          } else if (data.status === 'Installed') {
            refInstalledStatus.value = getI18n('已安装', 'Installed')
          } else if (data.status === 'Enable') {
            refInstalledStatus.value = getI18n('启用', 'Enable')
          } else if (data.status === 'Disable') {
            refInstalledStatus.value = getI18n('停用', 'Disable')
          } else if (data.status === 'Unkown') {
            refInstalledStatus.value = getI18n('未知', 'Unkown')
          }
        }
        if (data.code === 'is_pyhsical_card') {
          refInstalledDevice.value = getI18n('物理卡', 'Physical Card')
        }
      }
    })
}
function getCarrier () {
  if (refCarrier.value === 'SS') {
    return getI18n('S卡', 'S Card')
  }
  return refCarrier.value
}
function getCardType () {
  if (refCardTye.value === 'ESIM') {
    return getI18n('ESIM', 'ESIM')
  }
  return getI18n('物理卡', 'Physical Card')
}
</script>

<style scoped>
.line-center {
  text-align: center;
  padding-right: 0px !important;
  padding-left: 0px !important;
}
.line-center-value {
  font-size: 32px;
}
</style>
